import { clsx, type ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function formatTime(minutes: number): string {
  if (minutes === 0) return '0 min'
  if (minutes < 60) return `${minutes} min`
  
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  
  if (remainingMinutes === 0) return `${hours}u`
  return `${hours}u ${remainingMinutes}min`
}

export function getDifficultyColor(difficulty: string): string {
  switch (difficulty.toLowerCase()) {
    case 'gemakkelijk':
      return 'bg-green-100 text-green-800 border-green-200'
    case 'middel':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200'
    case 'moeilijk':
      return 'bg-red-100 text-red-800 border-red-200'
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200'
  }
}

export function getDifficultyLevel(difficulty?: string | null): number {
  switch ((difficulty || '').toLowerCase()) {
    case 'gemakkelijk':
      return 2
    case 'middel':
      return 3
    case 'moeilijk':
      return 5
    default:
      return 0
  }
}

export function getDifficultyAccentClass(difficulty?: string | null): string {
  switch ((difficulty || '').toLowerCase()) {
    case 'gemakkelijk':
      return 'text-green-700 dark:text-green-300'
    case 'middel':
      return 'text-amber-700 dark:text-amber-300'
    case 'moeilijk':
      return 'text-red-700 dark:text-red-300'
    default:
      return 'text-gray-400 dark:text-slate-400'
  }
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('nl-NL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
